import FilterManager, { Filter } from '../../managers/FilterManager'
import useQuery, { buildQueryKey } from '../hooks/useQuery'
import SelectMultipleBadgeFilter from './SelectMultipleBadgeFilter'
import SelectBadgeFilter from './SelectBadgeFilter'

interface Props {
    name: Filter
    values: string[]
    contractId?: number
    singleSelection?: boolean
    onApply: (newValue: string[]) => void
}

const SmartBadgeFilter = ({ name, values, contractId, singleSelection, onApply }: Props) => {
    const filterData = FilterManager.getFilter(name, contractId)

    const { status: optionsStatus, response: options } = useQuery({
        queryKey: buildQueryKey(filterData.key),
        queryFn: filterData.backendCall,
        cache: true
    })

    if (singleSelection) {
        return (
            <SelectBadgeFilter
                name={name}
                isLoading={optionsStatus === 'loading'}
                value={values[0]}
                options={options ?? []}
                onApply={newValue => onApply([newValue])}
            />
        )
    } else {
        return (
            <SelectMultipleBadgeFilter
                name={name}
                isLoading={optionsStatus === 'loading'}
                value={values}
                options={options ?? []}
                onApply={newValues => onApply(newValues)}
            />
        )
    }
}

export default SmartBadgeFilter
